import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AlertService } from 'src/app/services/alert/alert.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { TruckService } from 'src/app/services/truck/truck.service';
import { SpinnerService } from 'src/app/services/spinner/spinner.service';
import { NavigationExtras, Router } from '@angular/router';

@Component({
  selector: 'app-add-truck',
  templateUrl: './add-truck.page.html',
  styleUrls: ['./add-truck.page.scss'],
})
export class AddTruckPage implements OnInit {

  numberPlateForm: FormGroup;
  disabled: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private spinnerService: SpinnerService,
    private authService: AuthService,
    private numberPlateService: TruckService,
    private router: Router
  ) { 
    this.numberPlateForm = this.formBuilder.group({
      numberPlate: [
        { value: '', disabled: this.disabled }, 
        [Validators.required]
      ],
    });
  }

  ngOnInit() {
  }

  async confirmNumberPlate() {
    await this.alertService.confirm({
      messageKey: 'VEHICLE_CHECK_NUMBER_PLATE',
      okHandler: async () => await this.saveNumberPlate()
    });
  }

  async saveNumberPlate() {
    try {
      await this.spinnerService.show();

      const token = await this.authService.getToken();
      const numberPlate = this.numberPlateForm.getRawValue();

      const params = await this.numberPlateService.sendNumberPlate(token, numberPlate);
      if (params) {
        const merged = { ...numberPlate, ...params };
        const navigationExtras: NavigationExtras = { state: { numberPlateRes: merged } };

        this.router.navigate(['trucks/truck-data'], navigationExtras);
      } 

      await this.spinnerService.dismiss();
    } catch (err) {
      await this.spinnerService.dismissWithAlertError(err);
    }
  }

}
